import { useState, useEffect } from "react";
import { Nav, Modal, Button } from "react-bootstrap";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import { menuItems } from "../../menu.ts";
import MainLogo from "../../images/white-logo.png";
import { useSidebar } from "../../contexts/SidebarContext.tsx";

import "./Sidebar.scss";

const Sidebar = () => {
  const { isSidebarOpen, isCollapsed, closeSidebar, toggleCollapsed } = useSidebar();
  const location = useLocation();
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleItemClick = (item) => {
    if (item.action === "logout") {
      setShowLogoutModal(true);
    } else {
      // Close sidebar on mobile when navigating
      closeSidebar();
    }
    // For navigation items, NavLink will handle the routing automatically
  };

  const handleLogoutConfirm = () => {
    // Clear all authentication data
    localStorage.removeItem("authToken");
    sessionStorage.clear();

    // Close modal
    setShowLogoutModal(false);

    // Navigate to login page
    navigate("/");
  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      <section className={`sidebar-grid ${isSidebarOpen ? 'sidebar-open' : ''} ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
        <div className="d-flex justify-content-between align-items-center mb-3 sidebar-header">
          <figure>
            <img src={MainLogo} alt="" />
          </figure>
          {/* <button
            className="btn btn-sm btn-toggle"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? 1 : 2}
          </button> */}
        </div>

        <Nav className="">
          {menuItems.map((item) => {
            // Handle logout item differently
            if (item.action === "logout") {
              return (
                <Nav.Item key={item.id}>
                  <button
                    type="button"
                    className="nav-link d-flex align-items-center text-white logout-btn"
                    onClick={() => handleItemClick(item)}
                  >
                    {item.icon && (
                      <img
                        src={item.icon}
                        alt={item.title}
                        className="menu-icon me-2"
                      />
                    )}
                    <span className="menu-text">{item.title}</span>
                  </button>
                </Nav.Item>
              );
            }

            // Handle regular navigation items
            return (
              <Nav.Item key={item.id}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => {
                    const isCurrentActive =
                      location.pathname.startsWith(item.path) ||
                      (item.path === "/users" &&
                        location.pathname.startsWith("/billing-details")) ||
                      (item.path === "/orders" &&
                        location.pathname.startsWith("/order-details")) ||
                      (item.path === "/posthumousgifts" &&
                        location.pathname.startsWith("/posthumous-details")) ||
                      (item.path === "/milestonegifts" &&
                        location.pathname.startsWith("/milestone-details")) ||
                      (item.path === "/referral-discount" &&
                        location.pathname.startsWith("/discount-codes-details")) ||
                      (item.path === "/subscription-plans" &&
                        location.pathname.startsWith("/subscriptions/"));

                    return `nav-link d-flex align-items-center text-white ${
                      isCurrentActive ? "active" : ""
                    }`;
                  }}
                  onClick={() => handleItemClick(item)}
                  title={item.title}
                >
                  {item.icon && (
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="menu-icon me-2"
                    />
                  )}
                  <span className="menu-text">{item.title}</span>
                </NavLink>
              </Nav.Item>
            );
          })}
        </Nav>
      </section>

      {/* Logout Confirmation Modal */}
      <Modal
        show={showLogoutModal}
        onHide={handleLogoutCancel}
        centered
        className="delete-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span>
            <p className="mw-100">Are you sure you want to logout?</p>
            <p className="mw-100">
              You will need to sign in again to access your account.
            </p>
          </span>
        </Modal.Body>
        <Modal.Footer className="border-0 text-left gap-3">
          <Button
            className="border-bttn"
            variant="secondary"
            onClick={handleLogoutCancel}
            style={{ width: "30%", margin: "0" }}
          >
            Cancel
          </Button>
          <Button
            className="main-bttn"
            variant="danger"
            onClick={handleLogoutConfirm}
            style={{ width: "30%", margin: "0" }}
          >
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Sidebar;
